import { FC } from "react";
import PageSection from "../../parts/StaticPageSection";
import { Helmet } from "react-helmet";
import { LecalSection } from "../../parts/LecalSection";

export const TermsOfServicePage: FC = () => {
  return <>
    <Helmet>
      <title>利用規約 - Drop AI</title>
      <meta name="description" content="Drop AIの利用規約を確認できます。" />

      <meta property="og:url" content="https://drop4i.com/terms-of-service" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="利用規約 - Drop AI | 無料で使えるAI画像生成ツール" />
      <meta property="og:description" content="Drop AIの利用規約を確認できます。" />
    </Helmet>
    <PageSection title="Drop AI サービス利用規約">
      <div className="whitespace-pre-line">
          <div>
            株式会社 GO TO MARKET（以下「当社」といいます。）は、当社の提供するDrop AI（ https://drop4i.com、以下「本サービス」といいます。理由の如何を問わず、本サービスの利用者が遵守すべき事項、および利用者と当社との関係を定めるものです。本サービスの利用にあたっては、本利用規約が適用されます。本規約に同意される場合にのみ本サービスをご利用ください。
          </div>

      <LecalSection title="第1条（適用）" value={`1. 本規約は、本サービスの利用者と当社の間の本サービスの利用に関わる一切の関係に適用されるものとします。
2. 本規約における「利用者」は、本サービスにアカウント登録をしたユーザーを意味します。
3. 当社が本サービス上で掲載する本サービス利用に関するルールは、本規約の一部を構成するものとします。`}></LecalSection>

      <LecalSection title="第2条（禁止事項）" value={`利用者は、本サービスの利用にあたり、以下の各号のいずれかに該当する行為または該当すると当社が判断する行為をしてはなりません。
(1)法令に違反する行為または犯罪行為に関連する行為
(2)当社、本サービスの他の利用者またはその他の第三者に対する詐欺または脅迫行為
(3)公序良俗に反する行為
(4)当社、本サービスの他の利用者またはその他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利または利益を侵害する行為
(5)本サービスを通じ、以下に該当し、または該当すると当社が判断する情報を当社または本サービスの他の利用者に送信すること
・過度に暴力的または残虐な表現を含む情報
・コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報
・当社、本サービスの他の利用者またはその他の第三者の名誉または信用を毀損する表現を含む情報
・わいせつな画像
・過度にわいせつな表現を含む情報
・差別を助長する表現を含む情報
・自殺、自傷行為を助長する表現を含む情報
・薬物の不適切な利用を助長する表現を含む情報
・反社会的な表現を含む情報
・チェーンメール等の第三者への情報の拡散を求める情報
・他人に不快感を与える表現を含む情報
(6)本サービスのネットワークまたはシステム等に過度な負荷をかける行為
(7)本サービスの運営を妨害するおそれのある行為
(8)当社のネットワークまたはシステム等への不正アクセス
(9)当社または第三者になりすます行為、または意図的に虚偽の情報を流布させる行為
(10)当社、本サービスの他の利用者またはその他の第三者に不利益、損害、不快感を与える行為
(11)本サービス上で掲載する本サービス利用に関するルールに抵触する行為
(12)反社会的勢力等への利益供与
(13)Stable Diffusion など画像生成AIのライセンサー（以下「ライセンサー」といいます）が定める利用規約、プライバシーポリシーその他の規約に違反する行為またはそのおそれがある行為
(14)画像生成に使用したモデル、プロンプトまたはネガティブプロンプトについて、故意に虚偽の情報を記載する行為
(15)前各号の行為を直接または間接に惹起し、または容易にする行為
(16)前各号の行為を試みること
(17)その他、当社が不適切と判断する行為`}></LecalSection>

      <LecalSection title="第3条（本サービスの停止について）" value={`1. 当社は、以下のいずれかに該当する場合には、利用者に事前に通知することなく、本サービスの全部または一部の提供を停止または中断できるものとします。
1. 当社は、以下のいずれかに該当する場合には、利用者に事前に通知することなく、本サービスの全部または一部の提供を停止または中断できるものとします。
(1)本サービスのシステム点検または保守作業を行う場合
(2)地震、落雷、火災、風水害、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合
(3)コンピューター、通信回線等の障害等により本サービスの運営ができなくなった場合
(4)その他、当社が停止または中断を必要と判断した場合
2. 本サービスの停止または中断により、利用者が被った不利益または損害について、理由を問わず当社は一切の責任を負わないものとします。`}></LecalSection>

      <LecalSection title="第4条（本サービスの内容の変更等）" value={`当社は利用者に通知することなく本サービスの内容を変更、または本サービスの提供を中止できるものとします。また、これにより利用者に生じた損害について一切の責任を負わないものとします。

当社は利用者に通知することなく本サービスの内容を変更、または本サービスの提供を中止できるものとします。また、これにより利用者に生じた損害について一切の責任を負わないものとします。`}></LecalSection>

      <LecalSection title="第5条（利用者アカウント）" value={`1.登録情報の管理：利用者は、自己の責任において、本サービスのアカウント情報を適切に管理するものとします。
2.アカウント保持：利用者は、原則として1人当たり1アカウントのみ登録できるものとします。利用者は、いかなる場合にもアカウント情報を第三者に譲渡または貸与しもしくは第三者と共用することはできません。当社は、アカウント情報が第三者によって使用されたことで生じた損害について、当社に故意又は重大な過失がある場合を除き、一切の責任を負いません。
3.サービス解約：利用者は当社の定める手続きにより本サービスを解約できるものとします。本サービスを解約した場合、アカウント基本情報、決済情報および請求時の関連情報、生成履歴、購入履歴、サポート履歴、サブスクリプション情報など利用者に関する情報にアクセスができなくなります。`}></LecalSection>

      <LecalSection title="第6条（サブスクリプション）" value={`当社が提供する有償のサブスクリプションプランに係る商品・サービスの価格、それ以外に必要となる費用、代金の支払方法と支払時期、商品の引渡しまたはサービス提供の時期、中途解約の可否については、当社の特定商取引法に基づく表示に定めるところによります。`}></LecalSection>

      <LecalSection title="第7条（権利帰属）" value={`本サービスの利用を通じて生成された画像は個人利用および商業利用が可能です。ただし、利用者が生成した画像に関して利用者と第三者の間において紛争が生じた場合においても、当社は利用者に生じた損害を補償する責任を負わず、またこれに関与する責任を負うものではないものとします。

本サービスの利用を通じて生成された画像は個人利用および商業利用が可能です。ただし、利用者が生成した画像に関して利用者と第三者の間において紛争が生じた場合においても、当社は利用者に生じた損害を補償する責任を負わず、またこれに関与する責任を負うものではないものとします。 `}></LecalSection>

      <LecalSection title="第8条（免責）" value={`1. 当社が利用者に対して損害賠償義務を負う場合（消費者契約法その他の法律の適用による場合等）、賠償する損害の範囲は、損害の事由が生じた時点から遡って過去１ヶ月の期間に利用者から現実に受領した本サービスに関する利用料金の総額を上限とします。なお本条は、債務不履行責任、契約不適合責任、原状回復義務、不法行為その他損害発生原因を問わず全ての損害等に適用されるものとします。また、付随的損害、間接損害、特別損害、将来の損害および逸失利益にかかる損害については、賠償する責任を負わないものとします。
2. 当社は、本サービス上で掲載する情報等が利用者の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、利用者による本サービスの利用が利用者に適用のある法令または業界団体の内部規則等に適合すること、継続的に利用できること、および不具合が生じないことについて、明示または黙示を問わず何ら保証するものではありません。
3. 当社は、本サービスの内容につき如何なる保証も行うものではありません。本サービスの内容に誤りが発見された場合その他当社が必要と判断した場合において、当社が情報のアップデートをする場合がありますが、かかるアップデートを行う義務を当社が負うものではありません。
4. 利用者と他の利用者または利用者の顧客、利用者等第三者との間において生じた取引、連絡、紛争等については、当該利用者において処理および解決するものとし、当社はかかる事項について一切責任を負いません。
5. 本サービスにリンクされた当社以外のサイトおよびサービスの利用に伴うトラブルが発生した場合について、当社は一切責任を負わないものとします。
6. 当社が本サービスを提供するために利用している第三者のシステム等の仕様や規約が変更されたことにより、当社コンテンツの閲覧等、利用者が本サービスを利用することが不可能となった場合でも、利用者は当社に支払った利用料金について、当社に対し返金を求めることができないものとします。また、これにより、利用者または第三者が被ったいかなる不利益または損害について、一切の責任を負わないものとします。
7. 本サービスに関し、以下の各号の事項を利用者はあらかじめ承諾します。
(1)本サービスのレイアウトやデザインを含むユーザーインターフェースおよびユーザーエクスペリエンスが事前の予告なく変更する場合があること
(2)本サービスの機能ラインナップなどの方針が事前の予告なく変更する場合があること
(3)本サービスの利用条件が事前の予告なく変更する場合があること`}></LecalSection>

      <LecalSection title="第9条（通知または連絡の方法）" value={`1. 本サービスに関する当社から利用者への通知または連絡は、本サービスおよび当社がコーポレートサイト内の適宜の場所への掲示その他、当社が適当と判断する方法により行うものとします。
2. 本サービスに関する利用者から当社への連絡は、本サービスおよび当社コーポレートサイト内に設置するお問い合わせフォームより行うものとします。
3. 当社が利用者から受領したメールアドレスその他の連絡先に連絡または通知を行った場合、利用者は当該連絡または通知を受領したものとみなします。`}></LecalSection>

      <LecalSection title="第10条（利用者情報の取扱い）" value={`1. 本サービスによる利用者情報の取扱いについては、別途プライバシーポリシー（https://drop4i.com/privacypolicy）の定めによるものとし、利用者はこのプライバシーポリシーに従って当社が利用者の利用者情報を取扱うことについて同意するものとします。
2. 当社は、利用者が当社に提供した情報、データ等を、個人を特定できない形での統計的な情報として、当社の裁量で、利用および公開することができるものとします。利用者はこれに異議を唱えないものとします。`}></LecalSection>

      <LecalSection title="第11条（利用規約の変更）" value={`当社は、当社が必要と認めた場合は、本規約を変更できるものとします。本契約を変更する場合、変更後の本規約の施行時期および内容を本サービス上での掲示その他の適切な方法により周知し、または利用者に通知します。但し、法令上利用者の同意が必要となるような内容の変更の場合は、当社所定の方法で利用者の同意を得るものとします。`}></LecalSection>
      <LecalSection title="第12条（分離可能性）" value={`本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定は継続して完全に効力を有するものとします。`}></LecalSection>
      <LecalSection title="第13条（協議解決）" value={`当社および利用者は、本規約に定めのない事項または本規約の解釈に疑義が生じた場合には、誠意をもって協議し、これを処理解決するよう努めます。`}></LecalSection>
      <LecalSection title="第14条（準拠法、裁判管轄）" value={`1. 本規約の準拠法は日本法とします。
2. 本規約に起因し、または関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。`}></LecalSection>

<div className="mt-10">
{`株式会社GO TO MARKET
当社および利用者は、本規約に定めのない事項または本規約の解釈に疑義が生じた場合には、誠意をもって協議し、これを処理解決するよう努めます。`}
</div>
      </div>
    </PageSection>
  </>;
}